// extracted by mini-css-extract-plugin
export default {"outerContainer":"TradingModule_outerContainer__ctIQF","header":"TradingModule_header__8azZ7","body":"TradingModule_body__JFRkp","mainSection":"TradingModule_mainSection__VgG8D"};